import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/ibex_logo_new.png'


const _withScopeId = n => (_pushScopeId("data-v-68c9ce60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "case-report" }
const _hoisted_2 = { class: "flex align-base" }
const _hoisted_3 = { class: "header-title" }
const _hoisted_4 = { class: "header-id" }
const _hoisted_5 = { class: "header-case" }
const _hoisted_6 = { class: "loader" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "case-report-container" }
const _hoisted_10 = { class: "pdf_header show_for_pdf" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "IBEX"
}, null, -1))
const _hoisted_12 = { class: "section-title" }
const _hoisted_13 = { class: "case-report-observations-container" }
const _hoisted_14 = { class: "comments" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "section-title slide-report-title" }
const _hoisted_17 = { class: "slide-report-container" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 0,
  class: "details show_for_pdf"
}
const _hoisted_20 = { class: "highlighted" }
const _hoisted_21 = { class: "highlighted" }
const _hoisted_22 = { class: "controls" }
const _hoisted_23 = { class: "flex align-center buttons" }
const _hoisted_24 = ["title"]
const _hoisted_25 = {
  key: 0,
  class: "details"
}
const _hoisted_26 = { class: "highlighted" }
const _hoisted_27 = { class: "highlighted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CaseReportObservations = _resolveComponent("CaseReportObservations")!
  const _component_k_textarea = _resolveComponent("k-textarea")!
  const _component_SlideReport = _resolveComponent("SlideReport")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_pdfexport = _resolveComponent("pdfexport")!
  const _component_IbIcons = _resolveComponent("IbIcons")!
  const _component_IButton = _resolveComponent("IButton")!
  const _component_WorkflowStateButton = _resolveComponent("WorkflowStateButton")!
  const _component_IBTooltip = _resolveComponent("IBTooltip")!
  const _component_IModal = _resolveComponent("IModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_IModal, { onClose: _ctx.closeModal }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("reports.header")), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t("reports.case_report.caseId")), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.activeCaseId), 1)
        ])
      ]),
      body: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_6, _hoisted_8, 512), [
          [_vShow, _ctx.isLoading]
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_pdfexport, {
            class: "export-wrapper",
            ref: "contentToExport",
            keepTogether: '.prevent-split',
            scale: 0.4,
            margin: '1cm',
            "paper-size": 'A4',
            author: _ctx.completedBy,
            fileName: `case report ${_ctx.activeCaseId} ${_ctx.completedOn}`
          }, {
            default: _withCtx(() => [
              _createElementVNode("h1", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("span", null, _toDisplayString(_ctx.activeCaseId) + " " + _toDisplayString(_ctx.t("reports.header")), 1)
              ]),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.t("reports.case_report.case_observations")), 1),
              _createElementVNode("form", {
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                class: "case-report-observations__form",
                ref: "caseReportForm"
              }, [
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.insightsConfig.case_insights[_ctx.activeCase.tissue].length)
                    ? (_openBlock(), _createBlock(_component_CaseReportObservations, {
                        key: 0,
                        "case-id": _ctx.activeCaseId,
                        "case-report-observations": _ctx.caseReport?.observations,
                        disabled: _ctx.isCaseComplete(_ctx.activeCase),
                        onObservationChange: _ctx.checkValidity
                      }, null, 8, ["case-id", "case-report-observations", "disabled", "onObservationChange"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.t("reports.comments_title")), 1),
                    (!_ctx.isCaseComplete(_ctx.activeCase))
                      ? (_openBlock(), _createBlock(_component_k_textarea, {
                          key: 0,
                          class: "comments__input",
                          onKeydown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                          modelValue: _ctx.caseReportComments,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.caseReportComments) = $event)),
                          disabled: _ctx.isCaseComplete(_ctx.activeCase),
                          rows: 2,
                          placeholder: _ctx.t('reports.comments_placeholder')
                        }, null, 8, ["modelValue", "disabled", "placeholder"]))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "item-display",
                          innerHTML: _ctx.computedComments
                        }, null, 8, _hoisted_15))
                  ])
                ])
              ], 544),
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.t("reports.slide_report.header")), 1),
              _createElementVNode("section", _hoisted_17, [
                (!_ctx.hasCaseReport(_ctx.activeCaseId))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.t("reports.no_reports")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass([{ 'display-findings-in-pdf': _ctx.displayFindingsInPDF }, "case-report-slides-container"])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide) => {
                        return (_openBlock(), _createBlock(_component_SlideReport, {
                          class: "prevent-split",
                          key: slide.slideId,
                          slide: slide,
                          observations: _ctx.getObservations(slide.slideId),
                          comments: _ctx.getComments(slide.slideId),
                          onNavigateToSlide: _ctx.handleNavigateToSlide
                        }, null, 8, ["slide", "observations", "comments", "onNavigateToSlide"]))
                      }), 128))
                    ], 2))
              ]),
              (_ctx.caseReportComplete)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_component_i18n_t, {
                      keypath: "reports.pdf.confirmed",
                      tag: "span"
                    }, {
                      completedBy: _withCtx(() => [
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.completedBy), 1)
                      ]),
                      completedOn: _withCtx(() => [
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.completedOn), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["keepTogether", "scale", "author", "fileName"])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            (_ctx.config.enable_case_report_pdf_export && _ctx.caseReportComplete)
              ? (_openBlock(), _createBlock(_component_IButton, {
                  key: 0,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.exportPDF())),
                  text: _ctx.t('reports.actionButtonText.downloadAsPDF'),
                  themeColor: "white",
                  "fill-mode": "link"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IbIcons, { icon: "download_as_pdf" })
                  ]),
                  _: 1
                }, 8, ["text"]))
              : _createCommentVNode("", true),
            (_ctx.config.enable_case_report_json_export && _ctx.caseReportComplete)
              ? (_openBlock(), _createBlock(_component_IButton, {
                  key: 1,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exportJSON())),
                  text: _ctx.t('reports.actionButtonText.downloadAsJSON'),
                  themeColor: "white",
                  "fill-mode": "link"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IbIcons, {
                      icon: "download_as_json",
                      color: "primary"
                    })
                  ]),
                  _: 1
                }, 8, ["text"]))
              : _createCommentVNode("", true),
            (_ctx.config.enable_case_report_clipboard_export && _ctx.caseReportComplete)
              ? (_openBlock(), _createBlock(_component_IButton, {
                  key: 2,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.copyToClipboard())),
                  text: _ctx.t(_ctx.copyToClipboardText),
                  themeColor: "white",
                  "fill-mode": "link"
                }, {
                  default: _withCtx(() => [
                    (_ctx.isCopied)
                      ? (_openBlock(), _createBlock(_component_IbIcons, {
                          key: 0,
                          icon: "v_green_circle"
                        }))
                      : (_openBlock(), _createBlock(_component_IbIcons, {
                          key: 1,
                          icon: "copy_to_clipboard",
                          color: "primary"
                        }))
                  ]),
                  _: 1
                }, 8, ["text"]))
              : _createCommentVNode("", true),
            _createVNode(_component_IBTooltip, null, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "buttons",
                  title: _ctx.workflowStateButtonTitle
                }, [
                  _createVNode(_component_WorkflowStateButton, {
                    id: _ctx.activeCaseId,
                    "current-workflow-state": _ctx.activeCase.workflowState,
                    "is-enabled": _ctx.isCaseCompletionEnabled && _ctx.isFormValid,
                    "object-type": "case"
                  }, null, 8, ["id", "current-workflow-state", "is-enabled"])
                ], 8, _hoisted_24)
              ]),
              _: 1
            })
          ]),
          (_ctx.caseReportComplete)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createVNode(_component_i18n_t, {
                  keypath: "reports.pdf.confirmed",
                  tag: "span"
                }, {
                  completedBy: _withCtx(() => [
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.completedBy), 1)
                  ]),
                  completedOn: _withCtx(() => [
                    _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.completedOn), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["onClose"])
  ]))
}